import $ from 'jquery';

var StoreLocatorPinForm = (function () {
  'use strict';

  var init = function () {
    var checkboxes = $('.js__work_time_select').find('input:checkbox');
    $.each(checkboxes, function (index, checkbox) {
      toggleFields($(checkbox));
    });
    checkboxes.on('change', function () {
      toggleFields($(this));
    });

    const $categoryChoice = $('#app_store_locator_pin_category');
    const $resellerChoice = $('#app_store_locator_pin_reseller').parent().parent();
    toggleResellerField($categoryChoice, $resellerChoice);
    $categoryChoice.on('change', function () {
      toggleResellerField($categoryChoice, $resellerChoice);
    });
  };

  var toggleFields = function (checkbox) {
    var field = checkbox.parent().parent().find('.field');
    if (checkbox.is(':checked')) {
      field.addClass('disabled');
    } else if (checkbox.is(':not(:checked)')) {
      field.removeClass('disabled');
    }
  };

  var toggleResellerField = function ($categoryChoice, $resellerChoice) {
    if ($categoryChoice.val() !== 'iqos') {
      $resellerChoice.show();
    } else {
      $resellerChoice.hide();
    }
  };

  return {
    init: init,
  };
})();

export default StoreLocatorPinForm;
